import { animate } from '../../vendor/anime.esm.js';
import { DURATION, EASE, resolveDuration } from '../motion-tokens.js';

/**
 * Entrada del bloque `entradas`: la cabecera y, después, el contenedor del widget. Como en
 * `reserva-live`, NO se anima lo de dentro (calendario, sesiones, tipos): lo pinta el runtime al
 * hidratar (core/entradas-runtime.js) y animarlo por separado competiría con sus repintados.
 */
export const entradasAnim = (el) => {
    const head = el.querySelector('.entradas-cabecera');
    const widget = el.querySelector('.ne-bloque-widget');
    if (!head && !widget) return null;
    if (head) { head.style.opacity = '0'; head.style.transform = 'translateY(22px)'; }
    if (widget) { widget.style.opacity = '0'; widget.style.transform = 'translateY(28px)'; }
    if (head) {
        animate(head, { opacity: [0, 1], translateY: [22, 0], duration: resolveDuration(DURATION.normal), ease: EASE.refined });
    }
    if (widget) {
        animate(widget, {
            opacity: [0, 1], translateY: [28, 0],
            delay: head ? resolveDuration(DURATION.normal) * 0.35 : 0,
            duration: resolveDuration(DURATION.slow), ease: EASE.snappy,
        });
    }
    return null;
};
